import Projection from './projection';
import Shape from './shape';
import Vector, { ICoordinate } from './vector';

export class Point {
    x = 0;
    y = 0;
    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }
}

export default class Polygon extends Shape {
    points: Array<ICoordinate> = [];
    constructor() {
        super();
        this.points = [];
    }
    getAxes() {
        const v1 = new Vector(undefined),
            v2 = new Vector(undefined),
            axes: Vector[] = [];
        for (let i = 0, len = this.points.length - 1; i < len; i++) {
            v1.x = this.points[i].x;
            v1.y = this.points[i].y;

            v2.x = this.points[i + 1].x;
            v2.y = this.points[i + 1].y;

            axes.push(v1.edge(v2).normal());
        }

        v1.x = this.points[this.points.length - 1].x;
        v1.y = this.points[this.points.length - 1].y;

        v2.x = this.points[0].x;
        v2.y = this.points[0].y;

        axes.push(v1.edge(v2).normal());

        return axes;
    }
    project(axis: ICoordinate) {
        const scalars: Array<number> = [],
            v = new Vector(undefined);

        this.points.forEach(function (point) {
            v.x = point.x;
            v.y = point.y;
            scalars.push(v.dotProduct(axis));
        });

        // eslint-disable-next-line prefer-spread
        return new Projection(Math.min.apply(Math, scalars), Math.max.apply(Math, scalars));
    }
    addPoint(x: number, y: number) {
        this.points.push(new Point(x, y));
    }
    collidesWith(shape: Shape) {
        let axes: any = shape.getAxes();
        if (axes === undefined) {
            return false;
        } else {
            axes = axes.concat(this.getAxes());
            return !this.separationOnAxes(axes, shape);
        }
    }
}
